import { useEffect } from 'react'

export const useLockBodyScroll = (enabled: boolean = true) => {
  useEffect(() => {
    if (!enabled) {
      return
    }
    // Get original body overflow
    const originalOverflow = window.getComputedStyle(document.body).overflow
    const originalPosition = window.getComputedStyle(document.body).position
    const originalTop = window.getComputedStyle(document.body).top
    const originalWidth = window.getComputedStyle(document.body).width
    const scrollPosition = window.pageYOffset
    // Prevent scrolling on mount
    document.body.style.overflow = 'hidden'
    document.body.style.position = 'fixed'
    document.body.style.top = `-${scrollPosition}px`
    document.body.style.width = '100%'
    return () => {
      document.body.style.overflow = originalOverflow
      document.body.style.position = originalPosition
      document.body.style.top = originalTop
      document.body.style.width = originalWidth
      window.scrollTo(0, scrollPosition)
    }
  }, [enabled])
}
